export enum EnumEstadoConsultaFatura {
    FINALIZADAS = 0,
    ABERTAS = 1,
}